import { render, staticRenderFns } from "./UnsubscribeContacts.vue?vue&type=template&id=52995df2&scoped=true&"
import script from "./UnsubscribeContacts.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeContacts.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeContacts.vue?vue&type=style&index=0&id=52995df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52995df2",
  null
  
)

export default component.exports